module.exports = __webpack_public_path__ + "img/muted-plus-icon.5099ff2a.svg";